<template>
  <AppBanner>
    Edit Municipality
  </AppBanner>

  <template v-if="loading">
    <AppContentLoader
      :is-loading="loading"
      text="Loading municipality..."
    />
  </template>

  <template v-else-if="!municipality">
    <h1 class="mt-5 flex items-center justify-center h-full">
      Unable to load municipality. Please try again.
    </h1>
  </template>

  <template v-else>
    <MunicipalityForm :model="municipality" />
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppContentLoader } from '@/components/app';
import { AppBanner } from '@/components/banners';
import { MunicipalityForm } from '@/components/forms';

import { useHttp } from '@/composables';

const route = useRoute();

const loading = ref(true);
const municipality = ref(null);

onMounted(async () => {
  await loadMunicipality();
});

const loadMunicipality = async () => {
  const response = await useHttp().get(`/municipalities/${route.params.municipality}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    municipality.value = response.data;
  }

  loading.value = false;
};
</script>
